export const queryKeyFactory = {
    payments: (params) => ['payments', { params }],
    payment: (id) => ['payments', id],
};
